import React from 'react';
import { ResponsiveProp, ColumnWidth } from '@belong/types';
import { Columns, Column, RichText, TEXT_NODES } from '@belong/ui-components';
import { StyledSection } from './view.styles';

import { ISectionRichText } from './model';
import { getVariantStyling } from './getVariantStyling';

const DEFAULT_GRID_SIZE = { md: '5/6', lg: '2/3', xl: '1/2' } as ResponsiveProp<ColumnWidth>;

export const SectionRichText: React.FC<ISectionRichText> = ({
  id,
  anchorName,
  content,
  identifier,
  sectionStyles,
  variant
}: ISectionRichText) => {
  const stylingRenderers = getVariantStyling(variant);

  return (
    <StyledSection
      className="contentSection"
      data-contentid={id}
      data-identifier={identifier}
      data-testid="section-rich-text"
      id={anchorName}
      {...sectionStyles}
    >
      <Columns alignX="center">
        <Column width={stylingRenderers.gridSize || DEFAULT_GRID_SIZE}>
          <RichText
            alignment="left"
            contentLength="long"
            h2={TEXT_NODES.headingMedium}
            h3={TEXT_NODES.headingXSmall}
            h4={TEXT_NODES.headingXSmall}
            html={content}
            {...stylingRenderers}
          />
        </Column>
      </Columns>
    </StyledSection>
  );
};

export default SectionRichText;
